import { render, staticRenderFns } from "./IndividualProducts.vue?vue&type=template&id=d34afb22&scoped=true&"
import script from "./IndividualProducts.vue?vue&type=script&lang=js&"
export * from "./IndividualProducts.vue?vue&type=script&lang=js&"
import style0 from "./IndividualProducts.vue?vue&type=style&index=0&id=d34afb22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34afb22",
  null
  
)

export default component.exports